import { render, staticRenderFns } from "./CovidInfo.vue?vue&type=template&id=fd7a3d96&"
import script from "./CovidInfo.vue?vue&type=script&lang=js&"
export * from "./CovidInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports